import { useRef } from 'react';
import { Provider } from 'react-redux';
import { initStore } from '../store/store';
import SubscriptionsActionsHost from '../components/SubscriptionActionsHost';
import { jsx as _jsx } from "react/jsx-runtime";
export function SubscriptionActionsHostWrapper({
  objectId,
  children
}) {
  if (!objectId) {
    throw new Error('No objectId provided to SubscriptionsActionsHostWrapper');
  }
  const store = useRef(initStore());
  return /*#__PURE__*/_jsx(Provider, {
    store: store.current,
    children: /*#__PURE__*/_jsx(SubscriptionsActionsHost, {
      objectId: objectId,
      children: children
    })
  });
}